// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 502 ? "d2c86127" : chunkId) + "." + {"502":"747db531f8cd6dbb","896":"5e15f24a551ee5ce"}[chunkId] + ".js";
};